<template>
  <div class="modal custom-modal fade" id="add_contact" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Contact</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="createContact">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">
                    First Name
                    <span class="text-danger">*</span>
                  </label>
                  <input v-model="formCreateContact.first_name" class="form-control" type="text" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">Last Name</label>
                  <input v-model="formCreateContact.last_name" class="form-control" type="text" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                Email Address
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input v-model="formCreateContact.email" class="form-control" type="email" />
            </div>
            <div class="form-group">
              <label>
                Contact Number
                <span class="text-danger">*</span>
              </label>
              <input v-model="formCreateContact.phone_number" class="form-control" type="text" />
            </div>
            <div class="form-group">
              <!-- {{formCreateContact}} -->
              <label class="d-block">Group</label>
              <div class="task-wrapper">
                <div class="task-list-container">
                  <div class="task-list-body">
                    <ul id="task-list">
                      <template v-for="rowG in groupListArr">
                        <li
                          v-on:click="selectGroup(rowG.id);"
                          v-bind:id="rowG.id"
                          class="task"
                          :key="rowG.id"
                        >
                          <div class="task-container">
                            <span class="task-action-btn task-check">
                              <span class="action-circle large complete-btn" title="Select">
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <span class="task-label" contenteditable="false">{{rowG.name}}</span>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },
  data() {
    return {
      loading: false,
      formCreateContact: {
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: []
      }
    };
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  methods: {
    async createContact() {
      await this.$store
        .dispatch("contact/createContact", this.formCreateContact)
        .then(response => {
          this.formCreateContact.list_id.forEach((value, index) => {
            var element = document.getElementById(value);
            element.classList.remove("completed");
          });
          this.formCreateContact = {
            email: "",
            phone_number: "",
            first_name: "",
            last_name: "",
            list_id: []
          };

          this.$fire({
            title: "Success",
            text: "Data added successfully",
            type: "success",
            timer: 1000
          }).then(r => {});
        });
      // .catch(error => {
      //   console.log("errrrrr", error);
      //   this.$fire({
      //     title: "Error",
      //     text: error.msg,
      //     type: "error",
      //     timer: 1000
      //   }).then(r => {});
      // });
    },
    async selectGroup(id) {
      var element = document.getElementById(id);
      if (this.formCreateContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formCreateContact.list_id.forEach((value, index) => {
          if (value === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formCreateContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formCreateContact.list_id.push(id);
        }
      } else {
        element.classList.add("completed");
        this.formCreateContact.list_id.push(id);
      }
    }
  },
  async created() {},
  mounted() {},
  name: "create-contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/createContact.vue